'use client'

import Image from 'next/image'
import Link from 'next/link'

import clsx from 'clsx'
import { GrPowerReset } from 'react-icons/gr'

import { GITHUB_URL, TELEGRAM_URL, TWITTER_URL } from '../constants/url'

import { BugReportButton } from './BugReportButton'
import { FooterStat } from './FooterStat'

interface SocialsProps {
  className?: string
  handleReset?: () => void
  tvl?: string
  susdeYield?: string
  showBugReport?: boolean
}

export const Socials = ({ className, handleReset, showBugReport, susdeYield, tvl }: SocialsProps) => {
  const socials = [
    {
      alt: 'Twitter',
      href: TWITTER_URL,
      icon: '/shared/twitter.svg',
    },
    {
      alt: 'Github',
      href: GITHUB_URL,
      icon: '/shared/github.svg',
    },

    {
      alt: 'Telegram',
      href: TELEGRAM_URL,
      icon: '/shared/telegram.svg',
    },
  ]

  return (
    <div
      className={clsx(
        'flex flex-wrap justify-center items-center',
        handleReset && 'animate-in slide-in-from-right duration-500',
        className,
      )}
    >
      {socials.map(({ alt, href, icon }) => (
        <Link href={href} target="_blank" key={alt} className="group">
          <Image
            src={icon}
            width={24}
            height={24}
            alt={alt}
            className="h-6 w-6 group-hover:brightness-90 group-hover:saturate-200 transition-all duration-300"
          />
        </Link>
      ))}

      {handleReset && (
        <button className="text-[#808080] h-5 w-auto" title="Reset Wallets" onClick={handleReset}>
          <GrPowerReset />
        </button>
      )}
      {showBugReport && <BugReportButton />}
      {handleReset && (
        <>
          <FooterStat title="APY" stat={susdeYield} />
          <FooterStat title="TVL" stat={tvl} />
        </>
      )}
    </div>
  )
}
